// Global state slice for the ⌘K palette — placed in a hook so any component
// can open/close it. Keybinds (Cmd/Ctrl+K, Escape) are registered once at
// the Layout level.
import { create } from "zustand";

export const useSearchPaletteStore = create((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
}));

// Convenience hook with safer destructuring at call sites.
export const useSearchPalette = () => {
  const isOpen = useSearchPaletteStore((s) => s.isOpen);
  const open = useSearchPaletteStore((s) => s.open);
  const close = useSearchPaletteStore((s) => s.close);
  return { isOpen, open, close };
};
